<template>
  <v-container grid-list-md fluid text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar tabs scroll-target="#scrolling-activity" style="z-index: 1">
          <v-toolbar-title>
            {{ $t('configuration.configuration') }}
          </v-toolbar-title>
          <v-speed-dial
            v-if="userPermissions[possibleUserModulePermissions.WATCH_SETTINGS]"
            :key="tab"
            v-model="buttonFab.fab"
            absolute
            bottom
            left
            direction="bottom"
            open-on-hover
            transition="scale-transition"
            style="bottom: 0"
          >
            <template v-slot:activator>
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="currentTab.fabShow"
                    @click="currentTab.fabEnableBtn ? tabButton() : null"
                    :disabled="working.wDoor"
                    style="z-index: 99"
                    v-model="buttonFab.fab"
                    color="gradiente"
                    dark
                    fab
                    :small="$vuetify.breakpoint.xsOnly"
                    v-on="on"
                  >
                    <v-icon>{{ currentTab.icon }}</v-icon>
                    <v-icon>{{ currentTab.clear }}</v-icon>
                  </v-btn>
                  <!-- <v-btn
                    v-else-if="
                      !(activeFab.id == 1) &&
                      (((userPermissions[
                        possibleUserModulePermissions.UPDATE_SETTINGS
                      ] ||
                        userPermissions[
                          possibleUserModulePermissions.DOWNLOAD_DOORS
                        ]) &&
                        activeFab.id == 0) ||
                        (userPermissions[
                          possibleUserModulePermissions.UPDATE_PERMITS
                        ] &&
                          activeFab.id == 2))
                    "
                    :disabled="working.wDoor"
                    style="z-index: 99"
                    v-model="buttonFab.fab"
                    color="gradiente"
                    dark
                    fab
                    :small="$vuetify.breakpoint.xsOnly"
                    v-on="on"
                  >
                    <v-icon>{{ activeFab.icon }}</v-icon>
                    <v-icon>{{ activeFab.clear }}</v-icon>
                  </v-btn> -->
                </template>
                <span v-if="currentTab.fabShow">
                  {{ currentTab.fabTooltip }}
                </span>
                <!-- <span
                  v-else-if="
                    activeFab.id != 1 &&
                    (((userPermissions[
                      possibleUserModulePermissions.UPDATE_SETTINGS
                    ] ||
                      userPermissions[
                        possibleUserModulePermissions.DOWNLOAD_DOORS
                      ]) &&
                      activeFab.id == 0) ||
                      (userPermissions[
                        possibleUserModulePermissions.UPDATE_PERMITS
                      ] &&
                        activeFab.id == 2))
                  "
                  >Más opciones</span
                > -->
              </v-tooltip>
            </template>
            <v-tooltip
              right
              v-if="userPermissions[possibleUserModulePermissions.ADD_DOORS]"
              v-show="activeFab.id == 0"
            >
              <v-btn
                fab
                dark
                small
                color="gradiente"
                slot="activator"
                @click="!buttonFlag.addDoor ? (buttonFlag.addDoor = true) : ''"
              >
                <v-icon>add</v-icon>
              </v-btn>
              <span>{{ $t('configuration.add_door') }}</span>
            </v-tooltip>
            <v-tooltip
              right
              v-if="
                userPermissions[possibleUserModulePermissions.DOWNLOAD_DOORS]
              "
              v-show="activeFab.id == 0"
            >
              <v-btn
                @click="flags.downloadDoors = true"
                fab
                dark
                small
                color="gradiente"
                slot="activator"
              >
                <v-icon>file_download</v-icon>
              </v-btn>
              <span>{{ $t('configuration.download_doors') }}</span>
            </v-tooltip>
            <v-tooltip
              right
              v-show="
                userPermissions[possibleUserModulePermissions.CREATE_ROLE] &&
                activeFab.id == 2
              "
            >
              <v-btn
                fab
                dark
                small
                color="gradiente"
                slot="activator"
                @click="!flags.addFlag ? (flags.addFlag = true) : ''"
              >
                <v-icon>add</v-icon>
              </v-btn>
              <span>Crear rol</span>
            </v-tooltip>
          </v-speed-dial>
          <template v-slot:extension>
            <v-tabs v-model="tab" color="transparent" grow>
              <v-tabs-slider color="gradiente"></v-tabs-slider>
              <v-tab
                v-for="item in currentItems"
                :key="item.id"
                :style="tab + 1 == item.id ? '' : 'text-decoration: underline;'"
                :disabled="!item.enable"
                v-show="item.show"
              >
                {{ $t(item.langKey) }}
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-container
          elevation-2
          fluid
          id="scrolling-activity"
          style="max-height: 75vh"
          class="scrollDesign"
        >
          <v-layout
            row
            wrap
            v-if="userPermissions[possibleUserModulePermissions.WATCH_SETTINGS]"
          >
            <v-flex xs12>
              <v-tabs-items v-model="tab">
                <v-tab-item :key="1">
                  <ConfigurationMap
                    v-on:cancel="cancelAddDoor"
                    v-on:added="addedDoor"
                    :addDoor="buttonFlag.addDoor"
                    :permits="userPermissions"
                    :downloadDoors="flags.downloadDoors"
                    v-on:location="locationChanged"
                    v-on:zoom="zoomChanged"
                    v-on:branchLocation="BranchChanged"
                    v-on:downloaded="flags.downloadDoors = false"
                    v-on:timeZone="timezoneChanged"
                  ></ConfigurationMap>
                </v-tab-item>
                <v-tab-item :key="2">
                  <ConfigurationGeneral
                    :permits="userPermissions"
                    :saveFlag="flags.saveFlag"
                    v-on:wBranch="
                      working.wBranch = $event
                      flags.saveFlag = false
                    "
                    v-on:success="
                      toast.success = $event
                      flags.saveFlag = false
                    "
                    v-on:failed="
                      toast.failed = $event
                      flags.saveFlag = false
                    "
                  ></ConfigurationGeneral>
                </v-tab-item>
                <v-tab-item :key="3" style="min-height: 115vh">
                  <ConfigurationRole
                    :permits="userPermissions"
                    v-on:cancel="flags.addFlag = false"
                    :addFlag="flags.addFlag"
                    :updateFlag="flags.updateRoles"
                    v-on:success="success"
                    v-on:failed="failed"
                  ></ConfigurationRole>
                </v-tab-item>
                <v-tab-item :key="4">
                  <ConfigurationBrand
                    :updateDataBrandFromBranch="updateDataBrandFromBranch"
                    :permits="userPermissions"
                    :save="flags.updateBrand"
                    @loading="working.wBrand = $event"
                    @success="
                      toast.success = true
                      flags.updateBrand = false
                    "
                    @error="
                      toast.error = true
                      flags.updateBrand = false
                    "
                    @cancel="flags.updateBrand = false"
                    @brandData="onBrandData"
                  ></ConfigurationBrand>
                </v-tab-item>
                <v-tab-item :key="5">
                  <ConfigurationMobil
                    @resetUpdate="flags.updateProfiles = false"
                    :branch="getBranch"
                    :user="getUser"
                    :updateFlag="flags.updateProfiles"
                  ></ConfigurationMobil>
                </v-tab-item>
                <v-tab-item
                  :key="6"
                  v-show="
                    userPermissions[
                      possibleUserModulePermissions.WATCH_PAYMENTS
                    ]
                  "
                >
                  <ConfigurationPayments
                    :save="flags.updateOpenPayKey"
                    @loading="working.wBrand = $event"
                    @success="
                      toast.success = true
                      flags.updateOpenPayKey = false
                    "
                    @error="
                      toast.failed = true
                      flags.updateOpenPayKey = false
                    "
                    @cancel="flags.updateOpenPayKey = false"
                  ></ConfigurationPayments>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <loading
      v-model="working.wBranch || working.wRole || working.wBrand"
      text="Actualizando..."
    ></loading>
    <success v-model="toast.success" text="Actualización Exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { isNormalSchool } from '../../../plugins/GeneralMethods'
import { _getUserPermissions } from '../../../utils/genericUtils'
import error from '../../Dialogs/Error.vue'
import loading from '../../Dialogs/Loading.vue'
import success from '../../Dialogs/Success.vue'
import ConfigurationGeneral from '../../Sections/Configuration/Configuration-General.vue'
import ConfigurationMap from '../../Sections/Configuration/Configuration-Map.vue'
import ConfigurationMobil from '../../Sections/Configuration/Configuration-Mobil.vue'
import ConfigurationBrand from '../../Sections/Configuration/ConfigurationBrand'
import ConfigurationPayments from '../../Sections/Configuration/ConfigurationPayments'
import ConfigurationRole from '../../Sections/Configuration/ConfigurationRoles.vue'

class _Fab {
  constructor({ id, color, icon, clear, fabTooltip, fabShow, fabEnableBtn }) {
    this.id = id
    this.color = color
    this.icon = icon
    this.clear = clear
    this.fabTooltip = fabTooltip
    this.fabShow = fabShow
    this.fabEnableBtn = fabEnableBtn
  }
}

export default {
  components: {
    ConfigurationMap,
    ConfigurationGeneral,
    ConfigurationRole,
    ConfigurationBrand,
    ConfigurationMobil,
    ConfigurationPayments,
    loading,
    success,
    error,
  },
  data: () => ({
    brandData: {},
    updateDataBrandFromBranch: [],
    flags: {
      saveFlag: false,
      addFlag: false,
      updateRoles: false,
      downloadDoors: false,
      updateBrand: false,
      updateProfiles: false,
      updateOpenPayKey: false,
    },
    branchMarkerForm: {
      id: '',
      latitude: '',
      longitude: '',
      markLatitude: '',
      markLongitude: '',
      zoom: '',
    },
    buttonFab: {
      fab: false,
      hidden: false,
    },
    tab: null,
    items: [
      {
        enable: true,
        id: 1,
        name: 'Ajustes de Ubicación',
        availableWithAnyPermission: ['WATCH_SETTINGS'],
        langKey: 'configuration.location_settings_title',
      },
      {
        enable: true,
        id: 2,
        name: 'Ajustes Generales',
        availableWithAnyPermission: ['WATCH_SETTINGS'],
        langKey: 'configuration.general_settings_title',
      },
      {
        enable: true,
        id: 3,
        name: 'Permisos',
        availableWithAnyPermission: [
          'WATCH_SETTINGS',
          'CREATE_ROLE',
          'DELETE_ROLE',
          'UPDATE_PERMITS',
        ],
        langKey: 'configuration.permits_title',
      },
      {
        enable: true,
        id: 4,
        name: 'Ajustes del colegio matríz',
        availableWithAnyPermission: ['WATCH_SETTINGS'],
        langKey: 'configuration.main_school_settings_title',
      },
      {
        enable: true,
        id: 5,
        name: 'Ajustes del móvil',
        availableWithAnyPermission: ['WATCH_SETTINGS'],
        langKey: 'configuration.cell_phone_app_settings_title',
      },
      // { enable: false, id: 6, name: "Ajustes de pagos" , per:'WATCH_PAYMENTS' }
    ],
    itemsMorelia: [
      {
        enable: false,
        id: 1,
        name: 'Ajustes de Ubicación',
        availableWithAnyPermission: ['WATCH_SETTINGS'],
        langKey: 'configuration.location_settings_title',
      },
      {
        enable: false,
        id: 2,
        name: 'Ajustes Generales',
        availableWithAnyPermission: ['WATCH_SETTINGS'],
        langKey: 'configuration.general_settings_title',
      },
      {
        enable: true,
        id: 3,
        name: 'Permisos',
        availableWithAnyPermission: [
          'WATCH_SETTINGS',
          'CREATE_ROLE',
          'DELETE_ROLE',
          'UPDATE_PERMITS',
        ],
        langKey: 'configuration.permits_title',
      },
      {
        enable: false,
        id: 4,
        name: 'Ajustes del colegio matríz',
        availableWithAnyPermission: ['WATCH_SETTINGS'],
        langKey: 'configuration.main_school_settings_title',
      },
      {
        enable: false,
        id: 5,
        name: 'Ajustes del móvil',
        availableWithAnyPermission: ['WATCH_SETTINGS'],
        langKey: 'configuration.cell_phone_app_settings_title',
      },
      // { enable: false, id: 6, name: "Ajustes de pagos" , per:'WATCH_PAYMENTS', langKey: 'configuration.payment_adjustments_title', }
    ],
    currentItems: [],
    buttonFlag: {
      addDoor: false,
    },
    working: {
      wDoor: false,
      wBranch: false,
      wRole: false,
      wBrand: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    // permits: [],
    userPermissions: {},
    possibleUserModulePermissions: {
      // SETTINGS
      WATCH_SETTINGS: 'WATCH_SETTINGS',
      UPDATE_SETTINGS: 'UPDATE_SETTINGS',
      // DOORS
      ADD_DOORS: 'ADD_DOORS',
      DELETE_DOORS: 'DELETE_DOORS',
      DOWNLOAD_DOORS: 'DOWNLOAD_DOORS',
      // ROL
      CREATE_ROLE: 'CREATE_ROLE',
      DELETE_ROLE: 'DELETE_ROLE',
      // PERMITS
      UPDATE_PERMITS: 'UPDATE_PERMITS',
      // PAYMENTS
      WATCH_PAYMENTS_CONCEPTS: 'WATCH_PAYMENTS_CONCEPTS',
      ADD_PAYMENTS_CONCEPTS: 'ADD_PAYMENTS_CONCEPTS',
      UPDATE_PAYMENTS_CONCEPTS: 'UPDATE_PAYMENTS_CONCEPTS',
    },
    /**
     * @type {_Fab}
     */
    currentTab: {},
  }),
  watch: {
    tab() {
      this.fabShowOptionsHandler()
      this.getItemsByType()
    },
    getUser() {
      this.mapPermits()
      this.fabShowOptionsHandler()
      this.getItemsByType()
    },
    getBranch() {
      this.setupTab()
      this.fabShowOptionsHandler()
      this.getItemsByType()
    },
  },
  async mounted() {
    if (this.getUser.id) {
      this.mapPermits()
    }
    this.setupTab().then(() => {
      this.tabRedirecTo()
    })
  },
  methods: {
    async tabRedirecTo() {
      const urlParams = new URLSearchParams(window.location.href.split('?')[1])
      if (urlParams.size === 0) return
      const delay = 400
      const tab = urlParams.get('tab')
      if (tab === null) return

      await new Promise((res, _) => {
        const time = setTimeout(() => {
          this.tab = parseInt(tab)
          res()
          clearTimeout(time)
        }, delay)
      })
    },
    setupTab() {
      return new Promise((res, _) => {
        if (isNormalSchool(this.getBranch)) {
          this.tab = 0
        } else {
          this.tab = this.itemsMorelia.findIndex((it) => it.enable)
        }
        res()
      })
    },
    getItemsByType() {
      if (isNormalSchool(this.getBranch)) {
        this.currentItems = this.items.map((e) =>
          structuredClone({
            ...e,
            show: e.availableWithAnyPermission.some(
              (e) => this.userPermissions[e] === true
            ),
          })
        )
      } else {
        this.currentItems = this.itemsMorelia.map((e) =>
          structuredClone({
            ...e,
            show: e.availableWithAnyPermission.some(
              (e) => this.userPermissions[e] === true
            ),
          })
        )
      }
    },
    fabShowOptionsHandler() {
      this.currentTab = {}
      const options = {
        0: () => {
          const update =
            this.userPermissions[
              this.possibleUserModulePermissions.UPDATE_SETTINGS
            ]
          const create =
            this.userPermissions[this.possibleUserModulePermissions.ADD_DOORS]
          const download =
            this.userPermissions[
              this.possibleUserModulePermissions.DOWNLOAD_DOORS
            ]

          if (update) {
            return new _Fab({
              id: this.tab,
              color: 'indigo',
              icon: 'save',
              clear: 'save',
              fabTooltip: this.$t('configuration.save_changes'),
              fabShow: true,
              fabEnableBtn: true,
            })
          }
          if (create || download) {
            return new _Fab({
              id: this.tab,
              color: 'indigo',
              icon: 'more_vert',
              clear: 'more_horiz',
              fabTooltip: 'Opciones',
              fabShow: true,
              fabEnableBtn: false,
            })
          }

          return new _Fab({
            id: this.tab,
            color: 'indigo',
            icon: 'save',
            clear: 'save',
            fabTooltip: this.$t('configuration.save_changes'),
            fabShow: false,
            fabEnableBtn: false,
          })
        },
        1: () => {
          const show =
            this.userPermissions[
              this.possibleUserModulePermissions.UPDATE_SETTINGS
            ]
          return new _Fab({
            id: this.tab,
            color: 'indigo',
            icon: 'save',
            clear: 'save',
            fabTooltip: this.$t('configuration.save_changes'),
            fabShow: show,
            fabEnableBtn: true,
          })
        },
        2: () => {
          const update =
            this.userPermissions[
              this.possibleUserModulePermissions.UPDATE_PERMITS
            ]
          const create =
            this.userPermissions[this.possibleUserModulePermissions.CREATE_ROLE]
          const show = update || create

          if (update) {
            return new _Fab({
              id: this.tab,
              color: 'indigo',
              icon: 'save',
              clear: 'save',
              fabTooltip: this.$t('configuration.save_changes'),
              fabShow: show,
              fabEnableBtn: true,
            })
          }

          return new _Fab({
            id: this.tab,
            color: 'indigo',
            icon: 'more_vert',
            clear: 'more_horiz',
            fabTooltip: 'Opciones',
            fabShow: show,
            fabEnableBtn: false,
          })
        },
        3: () =>
          new _Fab({
            id: this.tab,
            color: 'indigo',
            icon: 'save',
            clear: 'save',
            fabTooltip: this.$t('configuration.save_changes'),
            fabShow:
              this.userPermissions[
                this.possibleUserModulePermissions.UPDATE_SETTINGS
              ],
            fabEnableBtn: true,
          }),
        4: () =>
          new _Fab({
            id: this.tab,
            color: 'indigo',
            icon: 'save',
            clear: 'save',
            fabTooltip: this.$t('configuration.save_changes'),
            fabShow:
              this.userPermissions[
                this.possibleUserModulePermissions.UPDATE_SETTINGS
              ],
            fabEnableBtn: true,
          }),
        5: () =>
          new _Fab({
            id: this.tab,
            color: 'indigo',
            icon: 'save',
            clear: 'save',
            fabTooltip: this.$t('configuration.save_changes'),
            fabShow:
              this.userPermissions[
                this.possibleUserModulePermissions.WATCH_PAYMENTS
              ],
          }),
      }

      this.currentTab = options[this.tab]()
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
    success(event) {
      this.working.wRole = false
      this.toast.success = event
      this.flags.updateRoles = false
    },
    failed(event) {
      this.toast.failed = event
      this.flags = {
        saveFlag: false,
        addFlag: false,
        updateRoles: false,
      }
      this.working = {
        wDoor: false,
        wBranch: false,
        wRole: false,
      }
    },
    tabButton() {
      switch (this.tab) {
        case 0:
          this.save()
          break
        case 1:
          this.flags.saveFlag = true
          break
        case 2:
          this.flags.updateRoles = true
          this.working.wRole = true
          break
        case 3:
          this.flags.updateBrand = true
          break
        case 4:
          this.flags.updateProfiles = true
          break
        case 5:
          this.flags.updateOpenPayKey = true
          break
      }
    },
    onBrandData(brand) {
      this.brandData = brand
    },
    save() {
      this.working.wBranch = true
      this.branchMarkerForm.id = this.getBranch.id
      var json = JSON.stringify(this.branchMarkerForm) // aqui tienes la lista de objetos en Json
      var obj = JSON.parse(json)
      this.$store
        .dispatch('branch/updateBranch', obj)
        .then((response) => {
          this.working.wBranch = false
          this.toast.success = true
          this._updateBrandIfHaveNoMoreBranches_BrandIsSameAsBranch()
        })
        .catch((error) => {
          this.working.wBranch = false
          this.toast.failed = true
        })
    },
    async _updateBrandIfHaveNoMoreBranches_BrandIsSameAsBranch() {
      if (this.brandData.isBrandSameAsBranch === false) return

      const newBrandLocation = {
        ...this.brandData,
        address: this.branchMarkerForm.address,
        latitude: this.branchMarkerForm.markLatitude,
        longitude: this.branchMarkerForm.markLongitude,
      }
      delete newBrandLocation.isBrandSameAsBranch
      this.$store.dispatch('brand/updateBrand', newBrandLocation)

      this.updateDataBrandFromBranch = [
        this.branchMarkerForm.address,
        this.branchMarkerForm.markLatitude,
        this.branchMarkerForm.markLongitude,
      ]
    },
    cancelAddDoor() {
      this.buttonFlag.addDoor = false
      this.working.wDoor = false
    },
    addedDoor() {
      this.buttonFlag.addDoor = false
      this.working.wDoor = false
    },
    locationChanged(event) {
      this.branchMarkerForm.latitude = event.latitude
      this.branchMarkerForm.longitude = event.longitude
    },
    BranchChanged(event) {
      this.branchMarkerForm.markLatitude = event.latitude
      this.branchMarkerForm.markLongitude = event.longitude
      this.branchMarkerForm.address = event.address
    },
    zoomChanged(event) {
      this.branchMarkerForm.zoom = event
    },
    timezoneChanged(event) {
      this.branchMarkerForm.timezone = event
    },
  },
  computed: {
    activeFab() {
      switch (this.tab) {
        case 0:
          return {
            id: 0,
            color: 'indigo',
            icon: 'save',
            clear: 'save',
            tooltip: 'Guardar cambios',
          }
        case 1:
          return {
            id: 1,
            color: 'red',
            icon: 'save',
            clear: 'save',
            tooltip: 'Guardar cambios',
          }
        case 2:
          return {
            id: 2,
            color: 'green',
            icon: 'save',
            clear: 'save',
            tooltip: 'Guardar roles',
          }
        case 3:
          return {
            id: 3,
            color: 'green',
            icon: 'save',
            clear: 'save',
            tooltip: 'Guardar cambios',
          }
        case 4:
          return {
            id: 4,
            color: 'green',
            icon: 'save',
            clear: 'save',
            tooltip: 'Guardar cambios',
          }
        case 5:
          return {
            id: 5,
            color: 'green',
            icon: 'save',
            clear: 'save',
            tooltip: 'Guardar cambios',
          }
        default:
          return {
            id: 3,
            color: 'green',
            icon: 'add',
            clear: 'cancel',
            tooltip: '',
          }
      }
    },
    //Mappers
    ...mapGetters(['getBranch', 'getUser']),
  },
}
</script>

<style>
.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}
</style>
